import Schema from "datagent/src/classes/Schema.class"

export function conditioner(parser, serializer){
    parser = new Schema(parser || {})
    serializer = new Schema(serializer || {})

    function parse(data, schema=parser){
        return schema.format(data)
    }

    function serialize(data, schema=serializer){
        return schema.format(data)
    }

    const context = {
        //operator
        parse,
        serialize,
        default: (schema=serializer)=>schema.default()
    }

    Object.defineProperties(context, {
        "parser":{
            get(){
                return parser
            }
        },
        "serializer": {
            get(){
                return serializer
            }
        }
    })

    return Object.freeze(context)
}